import React from 'react';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}
export function ProgressBar({
  currentStep,
  totalSteps
}: ProgressBarProps) {
  const percentage = currentStep / totalSteps * 100;
  return <div className="mb-10" data-id="element-132">
      {/* Step indicator - aligned left */}
      <div className="flex justify-between items-center mb-3" data-id="element-133">
        <span className="text-sm font-medium text-gray-600" data-id="element-134">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-sm font-medium text-gray-600" data-id="element-135">
          {Math.round(percentage)}%
        </span>
      </div>

      {/* Progress bar */}
      <div className="w-full h-1 bg-gray-200" data-id="element-136">
        <div className="h-full bg-yellow-500 transition-all duration-300 ease-out" style={{
        width: `${percentage}%`
      }} data-id="element-137" />
      </div>

      {/* Disclaimer - aligned left */}
      <p className="text-xs text-gray-500 mt-3 text-left" data-id="element-138">
        Disclaimer: All calculations are rough estimates only and not meant to
        be literal appraisals.
      </p>
    </div>;
}